export default __webpack_public_path__ + "src/images/packages/hillsneck-safari-lodge/3fc63d96b0d2764844dd970215a8f341-HillsNek Safari Camp.jpg";